module.exports = "<div class=\"pages-sider\" [ngClass]=\"{'side-collapsed':!sidebarToggle}\">\r\n  <span class=\"sidebar-top-line\"></span>\r\n  <du-menu [menuInfo]=\"menuInfo\"></du-menu>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layouts/sidebar/sidebar.component.html
// module id = ./src/app/shared/layouts/sidebar/sidebar.component.html
// module chunks = main